import { ROUTES } from "navigation/routes";

export const getStatementPdfUrl = (statementId: string) => {
  const URL = process.env.REACT_APP_API_URL;

  return `${URL}/${ROUTES.statements}/${statementId}/pdf`;
};
